export default __webpack_public_path__ + "static/media/img6.be6478ca.png";